<template>
  <div class="summaryD">
        <div class="D_one mb05">
            <timeline mode="alternate" >
                <timeline-item color="red" class="top2023">
                    <template #dot>
                        <ClockCircleOutlined  class="top2023_text" >
                            <div>2023</div> 
                            <div class="fs_0075 mt003">年</div>
                        </ClockCircleOutlined>
                    </template>
                </timeline-item>
                <timeline-item color="red" position="left">
                    <ClockCircleOutlined  class="hengxianR" >
                        <div >—</div>
                    </ClockCircleOutlined>
                    <div class="rtext wow  animate__fadeInRightBig">
                        <div class="color1 fw_6 fs_013">2023年</div>
                        <div class="color8 fs_0075"> <span class="fw_8"> · </span> 公司的软件团队被评为“江西省软件行业先进单位”</div>
                        <div class="color8 fs_0075"> <span class="fw_8"> · </span> 公司所开发的“茅庵岭VR & AR考古互动系统”被评为“江西省VR示范应用项目”</div>
                    </div>
                </timeline-item>
                <timeline-item color="red" position="right">
                    <ClockCircleOutlined  class="Lhengxian" >
                        <div >—</div>
                    </ClockCircleOutlined>
                    <div class="ltext wow animate__fadeInLeftBig">
                        <div class="color1 fw_6 fs_013">2022年</div>
                        <div class="color8 fs_0075"> 公司承接打造的“抚州高新区非公党群服务中心”及“直播电商基地”被评为“两新”党建的品牌项目 <span class="fw_8"> · </span> </div>
                    </div>

                </timeline-item>
                <timeline-item color="red" position="left">
                    <ClockCircleOutlined  class="hengxianR" >
                        <div >—</div>
                    </ClockCircleOutlined>
                    <div class="rtext wow  animate__fadeInRightBig">
                        <div class="color1 fw_6 fs_013">2021年</div>
                        <div class="color8 fs_0075"> <span class="fw_8"> · </span> 公司所承接打造的“全国青少年井冈山革命传统教育基地党,团史展览及教育中心“</div>
                        <div class="color8 fs_0075"> <span class="fw_8"> · </span> 被选为“庆祝建党一百周年”江西主会场/公司团队被评为“江西省VR产业优秀创新创业团队</div>
                    </div>
                   
                </timeline-item>
                <timeline-item color="red" position="right">
                    <ClockCircleOutlined  class="Lhengxian" >
                        <div >—</div>
                    </ClockCircleOutlined>
                    <div class="ltext wow animate__fadeInLeftBig">
                        <div class="color1 fw_6 fs_013">2020年</div>
                        <div class="color8 fs_0075">公司研发的工业互联网平台入选江西省首批VR应用示范项目。<span class="fw_8"> · </span> </div>
                        <div class="color8 fs_0075">公司顺利通过ISO9001体系和职业健康管理体系认证 <span class="fw_8"> · </span> </div>
                        <img src="@/assets/computer/fazhan/z139.png" class="mt02 timeline_img">
                    </div>
                  
                </timeline-item>

                <timeline-item color="red" position="left">
                    <ClockCircleOutlined  class="hengxianR" >
                        <div >—</div>
                    </ClockCircleOutlined>
                    <div class="rtext wow  animate__fadeInRightBig">
                        <div class="color1 fw_6 fs_013">2019年</div>
                        <div class="color8 fs_0075"><span class="fw_8"> · </span> 公司根据发展战略需要成立南昌世弘泛亚科技股份有限公司</div>
                        <div class="color8 fs_0075"><span class="fw_8"> · </span> 公司入选“中国(南昌)知识产权保护中心”首批保护名单</div>
                        <img src="@/assets/computer/fazhan/logo1.png" class="mt02 timeline_img">
                    </div>
                    
                </timeline-item>
                
                <timeline-item color="red" position="right" class="top2018">
                    <ClockCircleOutlined  class="Lhengxian" >
                        <div >—</div>
                    </ClockCircleOutlined>
                    <div class="ltext wow animate__fadeInLeftBig">
                        <div class="color1 fw_6 fs_013">2018年</div>
                        <div class="color8 fs_0075">作为首批VR企业入驻中国(南昌)VR产业基地<span class="fw_8"> · </span> </div>
                        <div class="color8 fs_0075">成为红谷滩区党群服务中心标杆性项目多媒体及自动化控制系统的总承包商<span class="fw_8"> · </span> </div>
                    </div>
                    
                </timeline-item>
                <!-- <timeline-item>
                </timeline-item> -->
                <timeline-item color="red" class="top2017">
                    <template #dot>
                        <ClockCircleOutlined  class="top2017_text" >
                            <div>2017</div> 
                            <div class="fs_0075 mt003">年</div>
                        </ClockCircleOutlined>
                    </template>
                </timeline-item>
                <timeline-item color="red" position="right">
                    <ClockCircleOutlined  class="Lhengxian" >
                        <div >—</div>
                    </ClockCircleOutlined>
                    <div class="ltext wow animate__fadeInLeftBig" >
                        <div class="color1 fw_6 fs_013">2017年</div>
                        <div class="color8 fs_0075">公司研发的平台入选“中国制造2025”省级专项扶持项目<span class="fw_8"> · </span> </div>
                        <div class="color8 fs_0075">公司多媒体信息化技术为“中国海博会”服务<span class="fw_8"> · </span> </div>
                        <div class="color8 fs_0075">公司被认证为国家高新技术企业<span class="fw_8"> · </span> </div>
                        <div class="color8 fs_0075">公司成为省内首家通过知识产权管理体系认证的VR企业<span class="fw_8"> · </span> </div>
                        <div class="color8 fs_0075">成为南昌市西湖区智慧党建服务中心项目多媒体及自动化控制系统的总承包商<span class="fw_8"> · </span> </div>
                        <img src="@/assets/computer/fazhan/s1.png" class="mt02 timeline_img">
                    </div>
                 
                </timeline-item>
                <timeline-item color="red" position="left">
                    <ClockCircleOutlined  class="hengxianR" >
                        <div >—</div>
                    </ClockCircleOutlined>
                    <div class="rtext wow  animate__fadeInRightBig">
                        <div class="color1 fw_6 fs_013">2016年</div>
                        <div class="color8 fs_0075"><span class="fw_8"> · </span> 公司团队携带众多VR研发成果亮相中国南昌虚拟现实产业基地新闻发布会</div>
                    </div>
                
                </timeline-item>
                <timeline-item color="red" position="left">
                    <ClockCircleOutlined  class="hengxianR" >
                        <div>—</div>
                    </ClockCircleOutlined>
                    <div class="rtext wow  animate__fadeInRightBig">
                        <div class="color1 fw_6 fs_013">2015年</div>
                        <div class="color8 fs_0075"><span class="fw_8"> · </span> 公司取得首项VR软件自主知识产权</div>
                        <img src="@/assets/computer/fazhan/s2.png" class="mt02 timeline_img">
                    </div>
                  
                </timeline-item>
                <timeline-item color="red" position="right">
                    <ClockCircleOutlined  class="Lhengxian" >
                        <div >—</div>
                    </ClockCircleOutlined>
                    <div class="ltext wow animate__fadeInLeftBig">
                        <div class="color1 fw_6 fs_013">2014年</div>
                        <div class="color8 fs_0075">作为江西唯--家VR企业参加中国智慧产业博览会<span class="fw_8"> · </span> </div>
                    </div>
                
                </timeline-item>
                <timeline-item color="red" >
                    <ClockCircleOutlined  class="hengxianR" >
                        <div >—</div>
                    </ClockCircleOutlined>
                    <div class="rtext wow  animate__fadeInRightBig">
                        <div class="color1 fw_6 fs_013">2013年</div>
                        <div class="color8 fs_0075"><span class="fw_8"> · </span> 公司取得第一个VR房地产应用项目</div>
                    </div>
                </timeline-item>

            </timeline>
        </div>
  </div>
</template>

<script setup>
import { ref, nextTick, onMounted } from 'vue'

import { Timeline, TimelineItem } from 'ant-design-vue';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons-vue';

const left = ref('left')
const  list= ref([
        { show: true, time: '2016年', address: '以鼎 · 北京', doc: '成立技术研发总部，位于北京CBD核心区域', img: 'tec' },
        { show: true, time: '2018年', address: '以鼎 · 上海', doc: '成立大型行业研究及商务中心', img: 'tec' },
        { show: true, time: '2018年', address: '以鼎 · 南通', doc: '成立国家级硬件开发实验室', img: 'tec' },
        { show: true, time: '2018年', address: '以鼎 · 上海', doc: '正式成立，致力于工业互联网及量子物理行业应用', img: 'tec' },
        { show: true, time: '2021年', address: '“以鼎人”仍在创造辉煌', doc: '成立技术研发总部，位于北京CBD核心区域', img: 'tec' },
        { show: false, time: '未来无限可能', address: '', doc: '', img: '' },
      ])
</script>

<style lang="less" scoped>
// <template>
 
// </template>
// <script lang="ts">
// import { ClockCircleOutlined } from '@ant-design/icons-vue';
// import { defineComponent } from 'vue';
// export default defineComponent({
//   components: {
//     ClockCircleOutlined,
//   },
// });
// </script>
.D_one{
    width: 85%;
    margin: 0 auto;
}
:deep .ant-timeline-item-head::after{
    width: 1rem;
    height: 0.1rem;
    background-color: red;
}
:deep .top2023{
    padding-bottom: 0.5rem;
}
:deep .ant-timeline-item-head{
    width: 0.04rem;
    height: 0.04rem;
    position: absolute;
    top: 0.005rem;
    right: 0.04rem !important;
    margin-inline-start: -0.0143rem!important;
}
:deep .top2023 .ant-timeline-item-head{
    width: 0.55rem;
    height: 0.55rem;
    display: flex;
    flex-flow: column;
    justify-content: center;
    border-radius: 100%;
}
.top2023_text{
    font-size: 0.13rem;
    color:#fff;
}
:deep .top2018{
    padding-bottom: 0.6rem;
}
:deep .top2017{
    padding-bottom: 0.7rem;
}
:deep .top2017 .ant-timeline-item-head{
    width: 0.55rem;
    height: 0.55rem;
    display: flex;
    flex-flow: column;
    justify-content: center;
    border-radius: 100%;
}
.top2017_text{
    font-size: 0.13rem;
    color:#fff;
}
:deep .ant-timeline .ant-timeline-item-head-red{
    background-color: #d20000;
    border-color: #d20000;
}
                  
.Lhengxian{
    // width: 0.15rem;
    // height: 0.0108rem;
    // background-color: #b8b8b8;
    position: absolute;
    // right: -0.05rem;
    // top: 0.0615rem;
    right: -0.040rem;
    top: 0;
    color: #b8b8b8;
}
.hengxianR{
    // width: 0.15rem;
    // height: 0.0108rem;
    // background-color: #b8b8b8;
    position: absolute;
    // left: -0.1rem;
    // top: 0.0615rem;
    top: 0;
    left: -0.08rem;
    color: #b8b8b8;
}
.ltext{
    padding-right: 0.25rem;
}
.rtext{
    padding-left: 0.25rem;
}
:deep .ant-timeline-item-tail{
    border-inline-start: 0.0108rem solid rgba(184, 184, 184, 0.8)
}
.timeline_img{
    width: 1.5rem;
}
</style>




  
  
